import store from '../store';
import {can_register} from "../utils/user";

export default {
  onlyLogged(next) {
    const user = store.getters.user;
    if (Object.keys(user).length > 0) {
      next();
    } else {
      next({
        name: 'login',
        query: { sessionExpired: true }
      });
    }
  },
  onlyIfEvent(next) {
    const events = store.getters.availableEvents;
    if (events.length > 0) {
      next();
    } else {
      next({
        name: 'home'
      });
    }
  },
  onlyAdmin(next) {
    const user = store.getters.user;
    if (user.admin) {
      next({
        replace: true
      });
    } else {
      next('notFound');
    }

  },
  onlyEditor(next) {
    const user = store.getters.user;
    if (user.editor || user.admin) {
      next();
    } else {
      next('notFound');
    }
  },
  onlyNotLogged(next) {
    const user = store.getters.user;
    if (Object.keys(user).length > 0) {
      next({
        name: 'home',
        query: { p: 1 }
      });
    } else {
      next();
    }
  },
  canRegister(next) {
    const user = store.getters.user;
    return can_register(user) ? this : next('notFound');
  }
};
